// src/helpers/rutaMovs.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "http://backretiro360.us-3.evennode.com";
const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

const clean = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );

export const getMovs = async (params = {}) => {
  const { data } = await API.get(p("mov"), { ...auth(), params });
  return Array.isArray(data?.movs) ? data.movs : [];
};

export const postMov = async (payload) => {
  const { data } = await API.post(p("mov"), clean(payload), auth());
  return data;
};

export const putMov = async (id, payload) => {
  const { data } = await API.put(p(`mov/${id}`), clean(payload), auth());
  return data;
};

export const deleteMov = async (id) => {
  const { data } = await API.delete(p(`mov/${id}`), auth());
  return data;
};